import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { CloseIcon } from 'components/Icons';

import styles from './FeedbackModalWrapper.module.scss';

type FeedbackModalWrapperProps = {
  handleCloseClick: () => void;
  children: React.ReactNode;
  title: string;
  subTitle: string;
  showTitle?: boolean;
  dataTestId?: string;
};
const FeedbackModalWrapper = ({
  handleCloseClick,
  showTitle = true,
  title,
  subTitle,
  children,
  dataTestId = 'feedback-modal',
}: FeedbackModalWrapperProps) => (
  <Box className={styles.container} data-testid={dataTestId}>
    <Button
      variant="text"
      className={styles.closeButton}
      disableFocusRipple
      disableRipple
      disableTouchRipple
      data-testid="close-button"
      onClick={handleCloseClick}
    >
      <CloseIcon />
    </Button>
    {showTitle && (
      <Box className={styles.header}>
        <Typography
          className={styles.title}
          component="p"
          variant="callout2"
          data-testid="feedback-modal-title"
        >
          {title}
        </Typography>
        <Typography
          component="p"
          variant="headline"
          className={styles.subTitle}
          data-testid="subfeedback-modal-title"
        >
          {subTitle}
        </Typography>
      </Box>
    )}
    {children}
  </Box>
);

export default FeedbackModalWrapper;
